import {ThemeColorPath} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

import {Nullish} from 'shared/web';

// Same colors as tasks but lighter .50 shade (tasks use .60/.80)
const CURRENT_USER_COLOR_MAP: Record<string, ThemeColorPath> = {
  HIGH: 'palettes.blue.50.100',
  MEDIUM: 'palettes.blue.50.100',
  LOW: 'palettes.blue.50.100',
  USER: 'palettes.blue.50.100',
};

const FIRST_USER_COLOR_MAP: Record<string, ThemeColorPath> = {
  HIGH: 'palettes.orange.50.100',
  MEDIUM: 'palettes.orange.50.100',
  LOW: 'palettes.orange.50.100',
  USER: 'palettes.orange.50.100',
};

const SECOND_USER_COLOR_MAP: Record<string, ThemeColorPath> = {
  HIGH: 'palettes.magenta.50.100',
  MEDIUM: 'palettes.magenta.50.100',
  LOW: 'palettes.magenta.50.100',
  USER: 'palettes.magenta.50.100',
};

const THIRD_USER_COLOR_MAP: Record<string, ThemeColorPath> = {
  HIGH: 'palettes.green.50.100',
  MEDIUM: 'palettes.green.50.100',
  LOW: 'palettes.green.50.100',
  USER: 'palettes.green.50.100',
};

const FOURTH_USER_COLOR_MAP: Record<string, ThemeColorPath> = {
  HIGH: 'palettes.purple.50.100',
  MEDIUM: 'palettes.purple.50.100',
  LOW: 'palettes.purple.50.100',
  USER: 'palettes.purple.50.100',
};

const OTHER_USER_COLOR_MAP: Record<string, ThemeColorPath> = {
  HIGH: 'palettes.neutral.50.100',
  MEDIUM: 'palettes.neutral.50.100',
  LOW: 'palettes.neutral.50.100',
  USER: 'palettes.neutral.50.100',
};

export const testDriveColors = [
  CURRENT_USER_COLOR_MAP,
  FIRST_USER_COLOR_MAP,
  SECOND_USER_COLOR_MAP,
  THIRD_USER_COLOR_MAP,
  FOURTH_USER_COLOR_MAP,
  OTHER_USER_COLOR_MAP,
];

export function getTestDriveUserColorVariants(userIndex: number | Nullish) {
  if (userIndex === undefined || userIndex === null) {
    return testDriveColors[0];
  }

  const colorMapIndex = match(userIndex)
    .with(-1, () => 5)
    .with(
      Pattern.when((n: number) => n >= 0 && n <= 4),
      () => userIndex
    )
    .with(
      Pattern.when((n: number) => n > 4),
      () => 5
    )
    .otherwise(() => 0);

  return testDriveColors[colorMapIndex];
}
